import { BlockStyleProps } from '../_types/blocksStyle';
import { CSSProperties } from 'react';

interface GetBlockStylesProps extends CSSProperties {
  textColor?: string
  align?: string,
  style?: Record<string, unknown>
  // [x: string]: any
}

export default function getBlockStyles({
  backgroundColor,
  textColor,
  maxWidth,
  width,
  align,
  style
}: GetBlockStylesProps) {
  const blockStyle: BlockStyleProps = {}

  // Determine styles, using stylelint-accepted const names.
  const background = backgroundColor || (style?.color as Record<string, string>)?.background
  const fontsize = (style?.typography as Record<string, string>)?.fontSize
  const fontweight = (style?.typography as Record<string, string>)?.fontWeight
  const textTransform = (style?.typography as Record<string, string>)?.textTransform
  const textAlign = (style?.typography as Record<string, string>)?.textAlign
  const textcolor = textColor || (style?.color as Record<string, string>)?.text

  const isHex = (hex: string) => {
    return hex.match(/[0-9A-Fa-f]{6}/g) || hex === 'white' || hex === 'black'
  }

  // Only add styles if set.
  if (background) {
    blockStyle.backgroundColor = background
  }
  if (textcolor) {
    blockStyle.color = textcolor
  }
  if (fontsize) {
    blockStyle.fontSize = fontsize as unknown as number
  }

  if (fontweight) {
    blockStyle.fontWeight = fontweight as unknown as number
  }

  if (textTransform) {
    blockStyle.textTransform = textTransform
  }

  if (textAlign) {
    blockStyle.textAlign = textAlign !== "left" ? textAlign : ""
  }
  if (align) {
    blockStyle.justifyContent = align === 'right' ? 'flex-end' : align === 'center' ? 'center' : ''
  }
  if (background) {
    blockStyle.backgroundColor = background
  }

  if (maxWidth) {
    blockStyle.width = '100%'
    blockStyle.maxWidth = maxWidth ? `${maxWidth}` : 'unset'
  }

  if (width) {
    if (isNaN(width as number)) {
      // If width is not a number, return full string.
      blockStyle.width = width
    } else {
      // If width is a number, return as percent.
      blockStyle.width = `${width}%`
    }
  }

  return blockStyle
}
